import { Container, Grid } from "@mui/material";
import { Divider } from "antd";
import React, { Component } from "react";

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { PostData } from "../api/service";
import { Typography } from "@material-ui/core";

const handleDragStart = (e) => e.preventDefault();

export default class HightlightShort extends Component {
  state = {
    loadedData: [],
    isLoaded: false,
  };

  componentDidMount() {
    PostData(`/getphotosforwebsitewithcaption`, {
      type: this.props.type,
    }).then((resp) => {
      this.setState({
        loadedData: resp,
        isLoaded: true,
      });
    });
  }

  render() {
    return (
      <div>
        {this.state.isLoaded && (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {this.state.loadedData
                  .length > 0 && (
                  <>
                    
                   
                      <AliceCarousel
                        responsive={{
                          0: {
                            items: 1,
                          },
                          1024: {
                            items: 4,
                            itemsFit: "contain",
                          },
                        }}
                        autoPlay={true}
                        autoWidth={true}
                        autoHeight={false}
                        autoPlayInterval={2000}
                        dotsDisabled={true}
                        buttonsDisabled={true}
                        mouseTracking
                        items={this.state.loadedData
                          //.filter((el) => el.type == this.props.type)
                          .map((el, index) => {
                            return (
                              <div key={index}>
                                <img
                                  src={el.url}
                                  onDragStart={handleDragStart}
                                  role="presentation"
                                  style={{
                                    width: "100%",
                                    height: "200px",
                                    objectFit: "contain",
                                  }}
                                />
                               
                                <Typography
                                  style={{
                                    fontWeight: 700,
                                    fontSize: 13,
                                    lineHeight: '0.1em',
                                    marginTop: 20,
                                    textAlign: "center",
                                  }}
                                >
                                  {el.caption}
                                </Typography>
                              </div>
                            );
                          })}
                      />
                   
                  </>
                )}
              </Grid>

             

              


              
            </Grid>
          </>
        )}
      </div>
    );
  }
}
